var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "rb-label",
      class: { "rb-label--dark": _vm.isDark },
      on: { click: _vm.onClick, keypress: _vm.onKeypress },
    },
    [
      _c("div", { staticClass: "rb-label__content" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm._t("right-icon"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }